(function () {
  function setupStoryImages() {
    var images = document.querySelectorAll('.page-product #MainContent .image-with-text__media img:not([data-soothee-story-observed])');
    if (!images.length) return;
    function start(image) {
      // Override native lazy loading once inside the look-ahead window so the
      // browser does not impose a second, shorter loading threshold.
      image.loading = 'eager';
      image.setAttribute('data-soothee-story-loading', 'true');
    }
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('.image-with-text__media img').forEach(start);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '2500px 0px', threshold: 0 }) : null;
    images.forEach(function (image) {
      image.setAttribute('data-soothee-story-observed', 'true');
      // The section uses content-visibility:auto. Observe its outer box because
      // descendants may not be laid out until much closer to the viewport.
      if (observer) observer.observe(image.closest('.shopify-section'));
      else start(image);
    });
  }

  function setupDeferredImages() {
    var images = Array.prototype.slice.call(
      document.querySelectorAll('img[data-soothee-deferred-image]:not([data-soothee-deferred-ready])')
    );

    if (!images.length) return;

    function loadImage(image) {
      var picture = image.closest('picture');
      if (picture) {
        picture.querySelectorAll('source[data-srcset]').forEach(function (source) {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        });
      }
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.setAttribute('data-soothee-deferred-ready', 'true');
    }

    window.sootheeLoadDeferredImage = loadImage;

    var mobileGalleryImages = [];
    if (window.matchMedia('(max-width: 767px)').matches) {
      mobileGalleryImages = images.filter(function (image) {
        return Boolean(image.closest('media-gallery'));
      });
      images = images.filter(function (image) {
        return !image.closest('media-gallery');
      });
    }

    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.hasAttribute('data-soothee-gallery-loader-ready')) return;
      gallery.setAttribute('data-soothee-gallery-loader-ready', 'true');

      function hydrateMediaById(mediaId) {
        if (!mediaId) return null;
        var existing = gallery.querySelector('[data-media-id="' + mediaId + '"]');
        if (existing) {
          loadMedia(existing);
          return existing;
        }

        var placeholder = gallery.querySelector('[data-soothee-media-placeholder="' + mediaId + '"]');
        var template = gallery.querySelector('template[data-soothee-gallery-media-template="' + mediaId + '"]');
        if (!placeholder || !template) return null;

        var fragment = template.content.cloneNode(true);
        var media = fragment.querySelector('[data-media-id="' + mediaId + '"]');
        if (!media) return null;
        placeholder.replaceWith(media);
        template.remove();

        var viewer = gallery.querySelector('[id^="GalleryViewer"]');
        if (viewer && typeof viewer.resetPages === 'function') viewer.resetPages();
        loadMedia(media);
        return media;
      }

      function hydrateAllMedia() {
        gallery.querySelectorAll('[data-soothee-media-placeholder]').forEach(function (placeholder) {
          hydrateMediaById(placeholder.getAttribute('data-soothee-media-placeholder'));
        });
      }

      function loadMedia(media) {
        if (!media) return;
        media.querySelectorAll('img[data-soothee-deferred-image]').forEach(loadImage);
      }

      gallery.sootheeHydrateMedia = hydrateMediaById;
      gallery.sootheeHydrateAllMedia = hydrateAllMedia;

      function loadThumbnail(image) {
        if (!image || !image.hasAttribute('data-soothee-deferred-thumbnail')) return;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
        image.removeAttribute('data-soothee-deferred-thumbnail');
      }

      function loadAllThumbnails() {
        gallery.querySelectorAll('img[data-soothee-deferred-thumbnail]').forEach(loadThumbnail);
      }

      gallery.addEventListener('click', function (event) {
        var target = event.target.closest('[data-target]');
        if (target && gallery.contains(target)) {
          loadThumbnail(target.querySelector('img[data-soothee-deferred-thumbnail]'));
          loadMedia(hydrateMediaById(target.dataset.target));
          return;
        }
        if (event.target.closest('.product__media-toggle, .product__modal-opener')) hydrateAllMedia();
      }, true);

      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (viewer) {
        viewer.addEventListener('pointerdown', hydrateAllMedia, { once: true, passive: true, capture: true });
      }

      gallery.querySelectorAll('.thumbnail-slider .slider-button').forEach(function (button) {
        button.addEventListener('pointerdown', loadAllThumbnails, { once: true, passive: true });
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') loadAllThumbnails();
        }, { once: true });
      });

      var thumbnailList = gallery.querySelector('[id^="Slider-Thumbnails"]');
      if (thumbnailList && 'IntersectionObserver' in window) {
        var thumbnailObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadThumbnail(entry.target);
            thumbnailObserver.unobserve(entry.target);
          });
        }, { root: thumbnailList, rootMargin: '0px', threshold: 0.01 });
        gallery.querySelectorAll('img[data-soothee-deferred-thumbnail]').forEach(function (image) {
          thumbnailObserver.observe(image);
        });
      }

      if ('IntersectionObserver' in window) {
        var placeholderObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            placeholderObserver.unobserve(entry.target);
            hydrateMediaById(entry.target.getAttribute('data-soothee-media-placeholder'));
          });
        }, { rootMargin: '120px 0px', threshold: 0.01 });

        gallery.querySelectorAll('[data-soothee-media-placeholder]').forEach(function (placeholder) {
          placeholderObserver.observe(placeholder);
        });
      }
    });

    if (window.customElements) {
      customElements.whenDefined('media-gallery').then(function () {
        var Gallery = customElements.get('media-gallery');
        if (!Gallery || Gallery.prototype.__sootheeDeferredMediaPatched) return;
        var originalSetActiveMedia = Gallery.prototype.setActiveMedia;
        Gallery.prototype.setActiveMedia = function (mediaId) {
          if (typeof this.sootheeHydrateMedia === 'function') this.sootheeHydrateMedia(mediaId);
          return originalSetActiveMedia.apply(this, arguments);
        };
        Gallery.prototype.__sootheeDeferredMediaPatched = true;
      }).catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      images.concat(mobileGalleryImages).forEach(loadImage);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadImage(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '80px 120px', threshold: 0.01 });

    // Tall description collages need a head start before the visitor reaches them.
    // Observe their container: percentage thresholds on a very tall image can
    // otherwise postpone loading even after its top approaches the viewport.
    var detailObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('img[data-soothee-deferred-image]').forEach(function (image) {
          image.loading = 'eager';
          loadImage(image);
        });
        detailObserver.unobserve(entry.target);
      });
    }, { rootMargin: '1200px 0px', threshold: 0 });
    var detailContainers = new Set();
    images.forEach(function (image) {
      var description = image.closest('.wb_gap_image');
      if (description) detailContainers.add(description);
      else observer.observe(image);
    });
    function observeDetails() {
      detailContainers.forEach(function (container) { detailObserver.observe(container); });
    }
    if (window.scrollY > 0 || !window.matchMedia('(max-width: 767px)').matches) observeDetails();
    else window.addEventListener('scroll', observeDetails, { once: true, passive: true });
  }

  function addAutoplayParams(src) {
    if (!src) return src;

    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('autoplay', '1');
      url.searchParams.set('mute', '1');
      url.searchParams.set('playsinline', '1');
      url.searchParams.set('enablejsapi', '1');
      return url.toString();
    } catch (error) {
      var separator = src.indexOf('?') === -1 ? '?' : '&';
      return src + separator + 'autoplay=1&mute=1&playsinline=1&enablejsapi=1';
    }
  }

  function setupDeferredEmbeds() {
    document.querySelectorAll('[data-soothee-deferred-embed]').forEach(function (embed) {
      if (embed.hasAttribute('data-soothee-embed-ready')) return;
      embed.setAttribute('data-soothee-embed-ready', 'true');

      var iframes = Array.prototype.slice.call(embed.querySelectorAll('iframe[data-src]'));
      var button = embed.querySelector('.soothee-deferred-embed__button');

      if (!iframes.length) {
        if (button) button.hidden = true;
        return;
      }

      iframes.forEach(function (iframe) {
        iframe.removeAttribute('src');
      });

      function loadEmbed() {
        if (embed.classList.contains('soothee-deferred-embed--loaded')) return;

        iframes.forEach(function (iframe) {
          iframe.src = addAutoplayParams(iframe.getAttribute('data-src'));
        });
        embed.classList.add('soothee-deferred-embed--loaded');
        if (button) button.hidden = true;
      }

      if (button) {
        button.addEventListener('click', loadEmbed);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadEmbed();
            observer.disconnect();
          });
        }, { rootMargin: '350px 0px', threshold: 0.05 });

        observer.observe(embed);
      }
    });
  }

  function run() {
    setupStoryImages();
    setupDeferredImages();
    setupDeferredEmbeds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
